import { createTheme } from '@mui/material';
import breakpoints from './breakpoints';
import * as components from './components';
import palette from './palette';
import shadows from './shadows';
import shape from './shape';
import spacing from './spacing';
import typography from './typography';
export const themeObject = {};
themeObject.shape = shape;
themeObject.breakpoints = breakpoints;
themeObject.components = components;
themeObject.palette = palette;
themeObject.shadows = shadows;
themeObject.spacing = spacing;
themeObject.typography = typography;
const theme = createTheme(themeObject);
export default theme;
export * from './shadows';
//# sourceMappingURL=index.js.map